import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';
import { PhTabComponent } from './components/ph-tab/ph-tab.component';

@Component({
  selector: 'app-ph-tabset',
  templateUrl: './ph-tabset.component.html',
  styleUrls: ['./ph-tabset.component.scss'],
})
export class PhTabsetComponent implements AfterContentInit {
  @ContentChildren(PhTabComponent) tabs: QueryList<PhTabComponent>;

  // contentChildren are set
  ngAfterContentInit() {
    // get all active tabs
    setTimeout(() => {
      const activeTabs = this.tabs.filter((tab) => tab.active);
      // if there is no active tab set, activate the first
      if (activeTabs.length === 0) {
        this.selectTab(this.tabs.first);
      }
    });
  }

  selectTab(tab) {
    // deactivate all tabs
    this.tabs.map((onetab: PhTabComponent) => {
      onetab.active = false;
    });
    // activate the tab the user has clicked on.
    if (tab) {
      tab.changeTab.emit();
      tab.active = true;
    }
  }

  changeTabName(name) {
    this.tabs.map((onetab) => {
      if (onetab.name === name) {
        this.selectTab(onetab);
      }
    });
  }
}
